import React from "react";

const RoleFormSkeleton = () => {
  return (
    <div className="animate-pulse space-y-6">
      {/* Form Fields Skeleton */}
      <div className="space-y-4">
        <div className="space-y-2">
          <div className="h-4 w-24 bg-gray-300 rounded"></div>
          <div className="h-10 w-full bg-gray-200 rounded"></div>
        </div>
        <div className="space-y-2">
          <div className="h-4 w-28 bg-gray-300 rounded"></div>
          <div className="h-10 w-full bg-gray-200 rounded"></div>
        </div>
        <div className="space-y-2">
          <div className="h-4 w-20 bg-gray-300 rounded"></div>
          <div className="h-24 w-full bg-gray-200 rounded"></div>
        </div>
      </div>
      
      {/* Permissions Section Skeleton */}
      <div className="mt-6 border-t pt-6">
        <div className="h-6 w-32 bg-gray-300 rounded mb-4"></div>
        <div className="h-4 w-96 bg-gray-200 rounded mb-4"></div>
        
        {/* Permission Cards Skeleton */}
        <div className="flex flex-col gap-4">
          {[1, 2, 3].map((index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-4 animate-pulse">
              {/* Module Level */}
              <div className="flex items-center gap-2 mb-3 pb-2 border-b">
                <div className="h-4 w-4 bg-gray-300 rounded"></div>
                <div className="h-5 w-32 bg-gray-300 rounded"></div>
              </div>
              
              {/* Submodules Skeleton */}
              <div className="ml-6 flex flex-col gap-3">
                {[1, 2].map((subIndex) => (
                  <div key={subIndex} className="border border-gray-100 rounded p-3 bg-gray-50">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="h-4 w-4 bg-gray-300 rounded"></div>
                      <div className="h-4 w-24 bg-gray-300 rounded"></div>
                    </div>
                    {/* Permissions Skeleton */}
                    <div className="ml-6 flex flex-wrap gap-3">
                      {[1, 2, 3, 4].map((permIndex) => (
                        <div key={permIndex} className="flex items-center gap-2">
                          <div className="h-4 w-4 bg-gray-300 rounded"></div>
                          <div className="h-4 w-20 bg-gray-300 rounded"></div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoleFormSkeleton;
